import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import getApiClient from './plugins/api-client'
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  loading: false,
  session: {
    token: null,
    refreshToken: null
  }
}

const actions = {
  checkSession: function(context) {
    const api = getApiClient(context)

    api.get('/users/me')
        .catch((error) => {
          if (error.response.status === 401) {
            context.dispatch('refreshToken')
          }
        })
  },

  refreshToken: function(context) {
    const api = getApiClient(context)

    let session = context.state.session
    context.commit('setSessionToken', null)

    return new Promise((resolve, reject) => {
      if (session.refreshToken) {
        api.post('auth/refresh', {
          'refresh_token': session.refreshToken
        })
            .then((response) => {
              let data = response.data
              context.commit('setSessionToken', data.token)
              context.commit('setSessionRefreshToken', data.refresh_token)
              resolve(data)
            })
            .catch((error) => {
              context.commit('unsetTokens')
              reject(error)
            })
      } else {
        reject('No token available')
      }
    })
  }
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  startLoading(state) {
    state.loading = true
  },
  stopLoading(state) {
    state.loading = false
  },
  setSessionToken(state, token) {
    state.session.token = token
  },
  setSessionRefreshToken(state, refreshToken) {
    state.session.refreshToken = refreshToken
  },
  unsetTokens(state) {
    state.session = {
      token: null,
      refreshToken: null
    }
  }
}

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [vuexLocal.plugin]
})